// Solo iOS Safari aggiunge sempre un header (URL) e un footer (data/ora, numero
// pagina) quando si stampa una PAGINA WEB, senza modo di disattivarlo via CSS
// (vedi lib/printPageSize.js e backend/label_pdf.py per il contesto completo).
// Su Android il PDF-handling varia troppo da dispositivo a dispositivo (a volte
// lo apre un visualizzatore diverso da Chrome, che non rispetta il formato
// pagina) mentre la stampa diretta della pagina HTML (window.print()) resta
// affidabile: per questo la scelta del flusso di stampa dipende dalla
// piattaforma, non è un'unica soluzione valida ovunque.
export function isIOS() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return true;
  // iPadOS 13+ si presenta come "Macintosh" ma ha il touch, a differenza di un vero Mac.
  return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}
